import { motion } from "framer-motion";
import { Bath, Sprout, Truck } from "lucide-react";
import { waLink } from "@/config";

const SERVICES = [
  {
    icon: Bath,
    title: "Banho & Tosa com Carinho",
    description:
      "Profissionais qualificados, produtos hipoalergênicos e ambiente seguro para o seu pet sair limpo e tranquilo.",
    cta: "Agendar horário",
    message: "Olá, Agro Carmo! Quero agendar um banho & tosa para o meu pet.",
  },
  {
    icon: Truck,
    title: "Entrega Agro & Pet em Domicílio",
    description:
      "Levamos sacos de ração, sal mineral e insumos pesados direto até a sua fazenda ou residência, sem custo na região.",
    cta: "Pedir entrega",
    message: "Olá, Agro Carmo! Quero pedir uma entrega em domicílio.",
  },
  {
    icon: Sprout,
    title: "Consultoria de Nutrição & Insumos",
    description:
      "Orientação de verdade para escolher a ração certa para o seu animal e os insumos ideais para a sua criação ou horta.",
    cta: "Falar com especialista",
    message: "Olá, Agro Carmo! Preciso de orientação sobre nutrição e insumos.",
  },
];

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="bg-forest py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-ochre">
            Serviços especializados
          </p>
          <h2 className="font-display text-3xl font-medium tracking-tight text-parchment sm:text-4xl lg:text-5xl">
            Muito além da prateleira
          </h2>
          <p className="mt-4 text-base text-parchment/70 sm:text-lg">
            A Agro Carmo cuida de tudo: do banho do seu cachorro ao caminhão de ração na sua fazenda.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {SERVICES.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={`service-card-${i}`}
              className="group flex flex-col rounded-[2rem] border border-parchment/10 bg-nightcard p-8 transition-[transform,border-color] duration-300 hover:-translate-y-2 hover:border-ochre/40"
            >
              <span className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-olive text-ochre transition-colors duration-300 group-hover:bg-clay group-hover:text-parchment">
                <service.icon className="h-6 w-6" />
              </span>
              <h3 className="font-display text-2xl font-medium text-parchment">{service.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-parchment/65">{service.description}</p>
              <a
                href={waLink(service.message)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-cta-${i}`}
                className="mt-6 inline-flex w-fit items-center gap-2 border-b-2 border-ochre/50 pb-1 text-sm font-semibold text-ochre transition-colors duration-300 hover:border-clay hover:text-clay"
              >
                {service.cta}
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
